// extracted by mini-css-extract-plugin
export default {"ModalHeader":"td58hK1DRtUSIKO_xzFc","ModalBody":"CXVeUPh29dT0q9PqNpr9","Form":"rObGgeUwPa0gcDtjligI","Buttons":"z9EIT92yzLGvpWXnnEwc"};